module.exports = __webpack_public_path__ + "img/pstitle.00ceb184.jpg";